<template>
    <div>
        <!-- Banner轮播 -->
        <div class="swiper-container pc_ban">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="tp_bj" style="background-image:url(/images/ban1.jpg)"></div>
                    <div class="container">
                        <div class="w_z">
                            <div class="z_s">
                                <h2 class="ani" swiper-animate-effect="fadeInDown">From Design to Installation</h2>
                                <h1 class="ani" swiper-animate-effect="fadeInDown" swiper-animate-delay=".3s">Complete
                                    Slaughtering Solutions for Pig, Cattle & Sheep</h1>
                                <a href="" class="ani" swiper-animate-effect="fadeInUp" swiper-animate-delay=".5s">Read
                                    More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="tp_bj" style="background-image:url(/images/ban2.jpg)"></div>
                    <div class="container">
                        <div class="w_z">
                            <div class="z_s">
                                <h2 class="ani" swiper-animate-effect="fadeInDown">From Design to Installation</h2>
                                <h1 class="ani" swiper-animate-effect="fadeInDown" swiper-animate-delay=".3s">
                                    Refrigeration overall solution service provider</h1>
                                <a href="" class="ani" swiper-animate-effect="fadeInUp" swiper-animate-delay=".5s">Read
                                    More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="tp_bj" style="background-image:url(/images/ban3.jpg)"></div>
                    <div class="container">
                        <div class="w_z">
                            <div class="z_s">
                                <h1 class="ani" swiper-animate-effect="fadeInDown">Comprehensive Solution Provider for
                                    the Food Processing Industry</h1>
                                <a href="" class="ani" swiper-animate-effect="fadeInUp" swiper-animate-delay=".3s">Read
                                    More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou1"></i></div>
            <div class="swiper-button-next"><i class="iconfont icon-zuojiantou1"></i></div>
        </div>

        <!-- 公司介绍 -->
        <div class="sy_gy">
            <div class="container">
                <div class="row">
                    <div class="gy_tp wow fadeInLeft" data-wow-delay=".5s">
                        <img src="/images/a1.jpg">
                        <div class="gy_bf" @click="openVideoModal"><span><i
                                    class="iconfont icon-sanjiaoright"></i></span></div>
                    </div>
                    <div class="gy_wz wow fadeInRight" data-wow-delay=".5s">
                        <div class="gy_bt">
                            <h1>We Provide <strong>Professional</strong> <br>One-stop Solutions</h1>
                        </div>
                        <div class="w_z">CNHONOR GROUP has six affiliated subsidiaries under its umbrella., two of which
                            are manufacturing enterprises: Shandong Huayu Mechanical Equipment Co., Ltd. (hereinafter
                            referred to as HONYO) and Shandong Aonaer Refrigeration Science & Technology Co., Ltd.
                            (hereinafter referred to as CNHONOR).</div>
                        <div class="y_s">
                            <div class="t_b"><img src="/images/tb1.png"></div>
                            <div class="n_r">
                                <h3>Comprehensive Manufacturing for Slaughtering & Food Processing Plants</h3>
                                <p>Two factories, complete equipment solutions, refrigeration systems — from China to
                                    the world.</p>
                            </div>
                        </div>
                        <div class="y_s">
                            <div class="t_b"><img src="/images/tb2.png"></div>
                            <div class="n_r">
                                <h3>Comprehensive Project Support from Start to Finish</h3>
                                <p>Drawings, animation videos, and on-site installation & commissioning — ensuring
                                    smooth and reliable operation.</p>
                            </div>
                        </div>
                        <a href="/about" class="btn_a">Read More <i
                                class="iconfont icon-zuojiantou1"></i><span></span></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 视频弹窗 -->
        <div class="tc_sp" v-show="videoModalVisible">
            <div class="g_b" @click="closeVideoModal"><i class="iconfont icon-guanbi"></i></div>
            <div class="vd_nr" v-if="videoModalVisible">
                <video id="videoID" width="100%" controls controlslist="nodownload" webkit-playsinline="" playsinline=""
                    x5-playsinline="" x-webkit-airplay="allow">
                    <source src="https://cdn.bosscaigou.com/waimao/video/aaa_compressed.mp4" type="video/mp4">
                </video>
            </div>
        </div>

        <!-- 数字统计 -->
        <div class="sy_sj">
            <div class="container">
                <div class="sj_zs">
                    <ul class="row">
                        <li>
                            <div class="t_b"><img src="/images/tb3.png"></div>
                            <div class="s_z"><b ref="counter1" class="counter">2003</b></div>
                            <div class="x_j">Company Established</div>
                        </li>
                        <li>
                            <div class="t_b"><img src="/images/tb5.png"></div>
                            <div class="s_z"><b ref="counter2" class="counter">150000</b>㎡</div>
                            <div class="x_j">Cover An Area</div>
                        </li>
                        <li>
                            <div class="t_b"><img src="/images/tb4.png"></div>
                            <div class="s_z"><b ref="counter3" class="counter">580</b>+</div>
                            <div class="x_j">On Duty Employees</div>
                        </li>
                        <li>
                            <div class="t_b"><img src="/images/tb9.png"></div>
                            <div class="s_z"><b ref="counter4" class="counter">150</b>+</div>
                            <div class="x_j">Number of engineers</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 服务行业 -->
        <div class="sy_hy">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Service Industry</h1>
                    <p>Refrigeration overall solution service provider</p>
                </div>
                <div class="row wow fadeInUp" data-wow-delay=".5s">
                    <div class="hy_lm"><a href="">
                            <div class="t_p"><img src="/images/hy1.jpg"></div>
                            <div class="w_z">
                                <div class="t_b"><img src="/images/hy1.png"></div>
                                <p>Slaughtering Industry</p>
                            </div>
                        </a></div>
                    <div class="hy_lm"><a href="">
                            <div class="t_p"><img src="/images/hy2.jpg"></div>
                            <div class="w_z">
                                <div class="t_b"><img src="/images/hy2.png"></div>
                                <p>Food Processing</p>
                            </div>
                        </a></div>
                    <div class="hy_lm"><a href="">
                            <div class="t_p"><img src="/images/hy3.jpg"></div>
                            <div class="w_z">
                                <div class="t_b"><img src="/images/hy3.png"></div>
                                <p>Refrigeration System</p>
                            </div>
                        </a></div>
                    <div class="hy_lm"><a href="">
                            <div class="t_p"><img src="/images/hy4.jpg"></div>
                            <div class="w_z">
                                <div class="t_b"><img src="/images/hy4.png"></div>
                                <p>Cold Chain Logistics</p>
                            </div>
                        </a></div>
                </div>
            </div>
        </div>

        <!-- 项目案例 -->
        <div class="sy_al">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Project Case</h1>
                    <a href="/turnkey_projects">More Cases</a>
                </div>
                <div class="al_zs wow fadeInUp" data-wow-delay=".5s">
                    <div class="swiper-container swiper-al">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="item in randomArticlesList" :key="item.id"
                                @click="handleClick(item)"><a :href="`/case_details/${item.id}`">
                                    <div class="t_p"><img :src="`https://cdn.bosscaigou.com/${item.himg}`"></div>
                                    <div class="w_z">
                                        <h3>{{ item.title }}</h3>
                                        <span>Read More <i class="iconfont icon-zuojiantou1"></i></span>
                                    </div>
                                </a></div>
                            <!-- <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/al1.jpg"></div>
                                    <div class="w_z">
                                        <h3>Qatar Slaughtering and Processing Supply Center</h3>
                                        <span>Read More <i class="iconfont icon-zuojiantou1"></i></span>
                                    </div>
                                </a></div>
                            <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/al1.jpg"></div>
                                    <div class="w_z">
                                        <h3>Qatar Slaughtering and Processing Supply Center</h3>
                                        <span>Read More <i class="iconfont icon-zuojiantou1"></i></span>
                                    </div>
                                </a></div> -->
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou"></i></div>
                    <div class="swiper-button-next"><i class="iconfont icon-zuojiantou"></i></div>
                </div>
            </div>
        </div>

        <!-- 合作品牌 -->
        <div class="sy_hz">
            <div class="container">
                <div class="sy_bt wow fadeInDown" data-wow-delay=".3s">
                    <h1>Co-branding</h1>
                    <p>Refrigeration overall solution service provider</p>
                </div>
                <!-- 品牌轮播上 -->
                <div class="hz_zs hz_za wow fadeInDown" data-wow-delay=".5s" ref="marquee1">
                    <ul class="bd">
                        <li><img src="/images/hz1.jpg" alt="" title=""></li>
                        <li><img src="/images/hz2.jpg" alt="" title=""></li>
                        <li><img src="/images/hz3.jpg" alt="" title=""></li>
                        <li><img src="/images/hz4.jpg" alt="" title=""></li>
                        <li><img src="/images/hz5.jpg" alt="" title=""></li>
                        <li><img src="/images/hz6.jpg" alt="" title=""></li>
                        <li><img src="/images/hz7.jpg" alt="" title=""></li>
                        <li><img src="/images/hz8.jpg" alt="" title=""></li>
                        <li><img src="/images/hz9.jpg" alt="" title=""></li>
                        <li><img src="/images/hz10.jpg" alt="" title=""></li>
                        <li><img src="/images/hz11.jpg" alt="" title=""></li>
                        <li><img src="/images/hz12.jpg" alt="" title=""></li>
                        <li><img src="/images/hz13.jpg" alt="" title=""></li>
                        <li><img src="/images/hz14.jpg" alt="" title=""></li>
                        <li><img src="/images/hz15.jpg" alt="" title=""></li>
                        <li><img src="/images/hz16.jpg" alt="" title=""></li>
                        <li><img src="/images/hz17.jpg" alt="" title=""></li>
                        <li><img src="/images/hz18.jpg" alt="" title=""></li>
                        <li><img src="/images/hz19.jpg" alt="" title=""></li>
                        <li><img src="/images/hz20.jpg" alt="" title=""></li>
                        <li><img src="/images/hz21.jpg" alt="" title=""></li>
                        <li><img src="/images/hz22.jpg" alt="" title=""></li>
                        <li><img src="/images/hz23.jpg" alt="" title=""></li>
                        <li><img src="/images/hz24.jpg" alt="" title=""></li>
                        <li><img src="/images/hz25.jpg" alt="" title=""></li>
                        <li><img src="/images/hz26.jpg" alt="" title=""></li>
                        <li><img src="/images/hz27.jpg" alt="" title=""></li>
                        <li><img src="/images/hz28.jpg" alt="" title=""></li>
                        <li><img src="/images/hz29.jpg" alt="" title=""></li>
                        <li><img src="/images/hz30.jpg" alt="" title=""></li>
                    </ul>
                </div>
                <!-- 品牌轮播下 -->
                <div class="hz_zs hz_zb wow fadeInUp" data-wow-delay=".5s" ref="marquee2">
                    <ul class="bd">
                        <li><img src="/images/hz31.jpg" alt="" title=""></li>
                        <li><img src="/images/hz32.jpg" alt="" title=""></li>
                        <li><img src="/images/hz33.jpg" alt="" title=""></li>
                        <li><img src="/images/hz34.jpg" alt="" title=""></li>
                        <li><img src="/images/hz35.jpg" alt="" title=""></li>
                        <li><img src="/images/hz36.jpg" alt="" title=""></li>
                        <li><img src="/images/hz37.jpg" alt="" title=""></li>
                        <li><img src="/images/hz38.jpg" alt="" title=""></li>
                        <li><img src="/images/hz39.jpg" alt="" title=""></li>
                        <li><img src="/images/hz40.jpg" alt="" title=""></li>
                        <li><img src="/images/hz41.jpg" alt="" title=""></li>
                        <li><img src="/images/hz42.jpg" alt="" title=""></li>
                        <li><img src="/images/hz43.jpg" alt="" title=""></li>
                        <li><img src="/images/hz44.jpg" alt="" title=""></li>
                        <li><img src="/images/hz45.jpg" alt="" title=""></li>
                        <li><img src="/images/hz46.jpg" alt="" title=""></li>
                        <li><img src="/images/hz47.jpg" alt="" title=""></li>
                        <li><img src="/images/hz48.jpg" alt="" title=""></li>
                        <li><img src="/images/hz49.jpg" alt="" title=""></li>
                        <li><img src="/images/hz50.jpg" alt="" title=""></li>
                        <li><img src="/images/hz51.jpg" alt="" title=""></li>
                        <li><img src="/images/hz52.jpg" alt="" title=""></li>
                        <li><img src="/images/hz53.jpg" alt="" title=""></li>
                        <li><img src="/images/hz54.jpg" alt="" title=""></li>
                        <li><img src="/images/hz55.jpg" alt="" title=""></li>
                        <li><img src="/images/hz56.jpg" alt="" title=""></li>
                        <li><img src="/images/hz57.jpg" alt="" title=""></li>
                        <li><img src="/images/hz58.jpg" alt="" title=""></li>
                        <li><img src="/images/hz59.jpg" alt="" title=""></li>
                        <li><img src="/images/hz60.jpg" alt="" title=""></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引入依赖
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import 'wowjs/css/libs/animate.css'
import { WOW } from 'wowjs';
// 引入swiper动画插件（需将swiper.animate.min.js放入public/js目录）
import '../../../public/js/swiper.animate.min.js'
// 引入countUp（数字计数，需将jquery.counterup.min.js改为原生版，这里用简单实现）
import { jumpTo } from '@/utils/myutils'
import { randomArticles } from '@/api'
export default {
    name: 'HomeContent',
    data() {
        return {
            // 随机文章
            randomArticlesList: [],
            // 视频弹窗
            videoModalVisible: false,
            // Cookie相关
            cookieBarVisible: true,
            cookieSettingsVisible: false,
            cookieDetailVisible: false,
            cookiePreferences: {
                analytics: true,
                marketing: true
            },
            // Swiper实例
            swiperBanner: null,
            swiperCase: null,
            // 品牌轮播定时器
            marqueeTimer1: null,
            marqueeTimer2: null,
            // 数字计数是否初始化
            counterInited: false
        }
    },
    mounted() {

        window.scrollTo(0, 0)
        // 初始化Banner轮播
        this.initBannerSwiper()
        // 初始化案例轮播
        this.initCaseSwiper()
        // 初始化品牌轮播
        this.initMarquee()
        // 初始化数字计数
        this.initCounter()
        // 微信视频播放兼容
        this.initWechatVideo()
        // 随机文章
        this.randomArticlesFuc()
        // 初始化WOW动画（如需保留）
        new WOW().init()
    },
    beforeDestroy() {
        // 销毁Swiper实例
        if (this.swiperBanner) this.swiperBanner.destroy(true, true)
        if (this.swiperCase) this.swiperCase.destroy(true, true)
        // 清除品牌轮播定时器
        if (this.marqueeTimer1) clearInterval(this.marqueeTimer1)
        if (this.marqueeTimer2) clearInterval(this.marqueeTimer2)
    },
    methods: {
        handleClick(item) {
            console.log(item)
            window.open(`/case_details/${item.id}`, '_self');
        },
        async randomArticlesFuc() {
            const data = await randomArticles({
                count: 6
            });
            if (data.code == 200) {
                this.randomArticlesList = data.data || [];
                this.$nextTick(() => this.initCaseSwiper());
            } else {
                this.$message.error(data.message);
            }
        },
        // ========== 视频弹窗 ==========
        openVideoModal() {
            this.videoModalVisible = true
            // 延迟播放视频（确保DOM渲染完成）
            this.$nextTick(() => {
                const video = document.getElementById('videoID')
                if (video) video.play()
            })
        },
        closeVideoModal() {
            const video = document.getElementById('videoID')
            if (video) {
                video.pause()
                video.currentTime = 0
            }
            this.videoModalVisible = false
        },

        // ========== Banner轮播初始化 ==========
        initBannerSwiper() {
            this.swiperBanner = new Swiper('.pc_ban', {
                on: {
                    init: function () {
                        window.swiperAnimateCache(this) // 缓存动画
                        window.swiperAnimate(this) // 执行初始化动画
                    },
                    slideChangeTransitionEnd: function () {
                        window.swiperAnimate(this) // 切换后执行动画
                    }
                },
                loop: true,
                speed: 1000,
                navigation: {
                    nextEl: '.pc_ban .swiper-button-next',
                    prevEl: '.pc_ban .swiper-button-prev'
                },
                pagination: {
                    el: '.pc_ban .swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 15000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                }
            })
        },

        // ========== 案例轮播初始化 ==========
        initCaseSwiper() {
            this.swiperCase = new Swiper('.swiper-al', {
                loop: true,
                speed: 1000,
                navigation: {
                    nextEl: '.al_zs .swiper-button-next',
                    prevEl: '.al_zs .swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-al .swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 10,
                breakpoints: {
                    641: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    993: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            })
        },

        // ========== 品牌轮播（原生Marquee） ==========
        initMarquee() {
            // 轮播配置
            if ($.fn.slide) {
                console.log('slide插件已加载')
                $(".hz_za").slide({
                    mainCell: ".bd",
                    autoPlay: true,
                    effect: "leftMarquee",
                    vis: 10,
                    interTime: 30,
                    mouseOverStop: false,
                    trigger: "click"
                })
                $(".hz_zb").slide({
                    mainCell: ".bd",
                    autoPlay: true,
                    effect: "leftMarquee",
                    vis: 10,
                    interTime: 30,
                    mouseOverStop: false,
                    opp: true,
                    trigger: "click"
                })
            }

            // 复制一份列表项实现无缝滚动
            // const marquee1El = this.$refs.marquee1.querySelector('.bd')
            // const marquee2El = this.$refs.marquee2.querySelector('.bd')
            // marquee1El.innerHTML += marquee1El.innerHTML
            // marquee2El.innerHTML += marquee2El.innerHTML

            // 上轮播（左滚）
            // this.marqueeTimer1 = setInterval(() => {
            //     if (marquee1El.scrollLeft >= marquee1El.scrollWidth / 2) {
            //         marquee1El.scrollLeft = 0
            //     } else {
            //         marquee1El.scrollLeft += 1
            //     }
            // }, config.speed)

            // // 下轮播（右滚）
            // this.marqueeTimer2 = setInterval(() => {
            //     if (marquee2El.scrollLeft <= 0) {
            //         marquee2El.scrollLeft = marquee2El.scrollWidth / 2
            //     } else {
            //         marquee2El.scrollLeft -= 1
            //     }
            // }, config.speed)

            // // 鼠标悬停暂停
            // this.$refs.marquee1.addEventListener('mouseenter', () => clearInterval(this.marqueeTimer1))
            // this.$refs.marquee1.addEventListener('mouseleave', () => {
            //     this.marqueeTimer1 = setInterval(() => {
            //         if (marquee1El.scrollLeft >= marquee1El.scrollWidth / 2) {
            //             marquee1El.scrollLeft = 0
            //         } else {
            //             marquee1El.scrollLeft += 1
            //         }
            //     }, config.speed)
            // })

            // this.$refs.marquee2.addEventListener('mouseenter', () => clearInterval(this.marqueeTimer2))
            // this.$refs.marquee2.addEventListener('mouseleave', () => {
            //     this.marqueeTimer2 = setInterval(() => {
            //         if (marquee2El.scrollLeft <= 0) {
            //             marquee2El.scrollLeft = marquee2El.scrollWidth / 2
            //         } else {
            //             marquee2El.scrollLeft -= 1
            //         }
            //     }, config.speed)
            // })
        },

        // ========== 数字计数 ==========
        initCounter() {
            // 简单版countUp实现
            const counters = [
                { el: this.$refs.counter1, target: 2003, duration: 1000 },
                { el: this.$refs.counter2, target: 150000, duration: 1000 },
                { el: this.$refs.counter3, target: 580, duration: 1000 },
                { el: this.$refs.counter4, target: 150, duration: 1000 }
            ]

            // 监听滚动，进入视图后开始计数
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.counterInited) {
                        this.counterInited = true
                        counters.forEach(item => {
                            this.countUp(item.el, item.target, item.duration)
                        })
                        observer.disconnect()
                    }
                })
            }, { threshold: 0.5 })

            // 观察数字统计区域
            observer.observe(document.querySelector('.sy_sj'))
        },
        // 数字递增动画
        countUp(el, target, duration) {
            let start = 0
            const step = duration / target
            const timer = setInterval(() => {
                start += Math.ceil(target / duration)
                el.textContent = start
                if (start >= target) {
                    clearInterval(timer)
                    el.textContent = target
                }
            }, step)
        },
        // ========== 数字计数 ==========
        initCounter() {
            const counters = [
                { el: this.$refs.counter1, target: 2003, duration: 1000 },
                { el: this.$refs.counter2, target: 150000, duration: 1000 },
                { el: this.$refs.counter3, target: 580, duration: 1000 },
                { el: this.$refs.counter4, target: 150, duration: 1000 }
            ]

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.counterInited) {
                        this.counterInited = true
                        counters.forEach(item => {
                            this.countUp(item.el, item.target, item.duration)
                        })
                        observer.disconnect()
                    }
                });
            }, { threshold: 0.5 });

            observer.observe(document.querySelector('.sy_sj'));
        },

        // ✅ 重写后的数字递增动画（按你的思路：0 开始 → 记录每一步 → 到达目标）
        countUp(el, target, duration) {
            // 目标不能小于0
            if (target < 0) target = 0;

            let current = 0; // 从 0 开始
            const frameRate = 60; // 标准动画帧率
            const totalFrames = Math.ceil(duration / (1000 / frameRate)); // 总帧数
            let frame = 0;

            // 每一帧要增加的数字（均匀递增）
            const increment = target / totalFrames;

            // 动画循环
            const timer = setInterval(() => {
                frame++;
                current = Math.min(Math.round(increment * frame), target); // 计算当前数字

                el.textContent = current; // 更新页面

                // 到达目标 → 结束
                if (frame >= totalFrames || current >= target) {
                    clearInterval(timer);
                    el.textContent = target; // 确保最终精准等于目标值
                }
            }, 1000 / frameRate);
        },

        // ========== 微信视频兼容 ==========
        initWechatVideo() {
            document.addEventListener("WeixinJSBridgeReady", () => {
                const video = document.getElementById("videoID")
                if (video) video.play()
            }, false)
        },

        // ========== Cookie相关 ==========
        // 切换Cookie设置面板
        toggleCookieSettings() {
            this.cookieSettingsVisible = !this.cookieSettingsVisible
        },
        // 接受所有Cookie
        acceptAllCookies() {
            this.cookiePreferences.analytics = true
            this.cookiePreferences.marketing = true
            this.cookieBarVisible = false
            this.cookieSettingsVisible = false
            // 可添加本地存储逻辑
            localStorage.setItem('cookieAccepted', 'all')
        },
        // 切换单个Cookie选项
        toggleCookie(type) {
            this.cookiePreferences[type] = !this.cookiePreferences[type]
        },
        // 保存Cookie设置
        saveCookieSettings() {
            this.cookieBarVisible = false
            this.cookieSettingsVisible = false
            // 可添加本地存储逻辑
            localStorage.setItem('cookiePreferences', JSON.stringify(this.cookiePreferences))
        },
        // 打开Cookie详情
        openCookieDetail() {
            this.cookieDetailVisible = true
        },
        // 关闭Cookie详情
        closeCookieDetail() {
            this.cookieDetailVisible = false
        }
    }
}
</script>

<style>
/* 引入首页相关样式 */

/* 品牌轮播样式（确保无缝滚动） */
/* .hz_zs {
    overflow: hidden;
}

.hz_zs .bd {
    display: flex;
    white-space: nowrap;
    padding: 10px 0;
}

.hz_zs .bd li {
    display: inline-block;
    margin: 0 10px;
}

.hz_zs .bd li img {
    height: 60px;
    object-fit: contain;
} */

/* 
.toggle-switch {
    width: 40px;
    height: 20px;
    background: #ccc;
    border-radius: 10px;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
}

.toggle-switch.checked {
    background: #007bff;
}

.toggle-switch.checked::after {
    left: 20px;
}

.toggle-switch::after {
    content: '';
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition: left 0.3s;
}

.toggle-switch.disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.cookie {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.cookie_wz {
    background: #fff;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
    position: relative;
}

.ck_gb {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
} */

/* 视频弹窗样式 */
.tc_sp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.tc_sp .g_b {
    align-self: flex-end;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    margin-bottom: 20px;
}

.tc_sp .vd_nr {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tc_sp video {
    max-width: 100%;
    max-height: 80vh;
}
</style>